import * as z from "zod";

export const disconnectConnection = {
  name: "disconnectConnection" as const,
  input: z.object({ integrationId: z.string(), connectionId: z.string() }),
  output: z.object({ success: z.boolean(), message: z.string().optional() }),
};
